import {
    ChangeRecordValue,
    RecorderData, ResizeRecordValue, ScrollRecordValue
} from "../../Shared/Shared";
import {PlayerBase} from "./PlayerBase";
import {MousePlayer} from "./MousePlayer";
import "jQuery";
import {Player} from "../Player";
declare var smartSessionRecordingInitialProperties:any;
export class ResizePlayer extends PlayerBase{
    constructor(private player:Player){
        super();
    }

    public async Execute(currentTime: number, record: RecorderData<ResizeRecordValue>) {
        return new Promise<number>(async (resolve)=>{
            let difference:number=record.time-currentTime;
            if(difference>0)
                await this.Delay(difference);

            smartSessionRecordingInitialProperties.width=record.value.width;
            smartSessionRecordingInitialProperties.height=record.value.height;

            this.player.AdjustIframeZoom();
            resolve(record.time);

        });
    }



}


// WEBPACK FOOTER //
// ./Player/PlayerElements/ResizePlayer.ts